import React from 'react';
import {AbstractStand} from "./AbstractStand";

export const StandPPS = (props) => <AbstractStand height="20" width="40" type={"PPS"} {...props}/>;

